import React, { useEffect, useState } from "react";
import Accordion from "../components/accordion";
import { useTheme } from "next-themes";
import { getFAQs } from "../services/learn.service";
import toast from "react-hot-toast";
import { customToast } from "../components/toasts";
import { useI18n } from "../hooks/useI18n";

const Faqs = () => {
  const [screenSize, setScreenSize] = useState();
  const [faqData, setFaqData] = useState([]);
  const [loading, setLoading] = useState(true);

  const { isRTL } = useI18n();

  const { theme } = useTheme();

  const fetchFaqsDataOnMount = async () => {
    try {
      setLoading(true);
      const response = await getFAQs();

      if (!response.error || !response.data) {
        setFaqData(response.data);
      } else {
        toast((t) => customToast("An Error Occurred, Try Reloading the Page", "error", t), {
          duration: 3000,
          removeDelay: 1000,
          style: {
            padding: "0.75rem",
            margin: "0",
            minWidth: "200px",
            backgroundColor: "rgb(255,255,255)",
          },
        });
      }
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFaqsDataOnMount();

    const accordionContainer = document.getElementById("faqAccordion");

    accordionContainer.addEventListener("shown.bs.collapse", function (event) {
      const accordionItem = event.target.closest(".accordion-item");
      const sideBar = accordionItem.querySelector(".side-bar");
      sideBar.style.backgroundColor = theme === "light" ? "rgb(78, 112, 237)" : "rgb(203, 110, 209)";
    });

    accordionContainer.addEventListener("hidden.bs.collapse", function (event) {
      const accordionItem = event.target.closest(".accordion-item");
      const sideBar = accordionItem.querySelector(".side-bar");
      sideBar.style.backgroundColor = theme === "light" ? "rgb(203, 110, 209)" : "rgb(78, 112, 237)";
    });

    const resizeHandler = () => {
      setScreenSize(window?.innerWidth);
    };

    resizeHandler();

    window.addEventListener("resize", resizeHandler);

    return () => {
      window.removeEventListener("resize", resizeHandler);
    };
  }, []);

  return (
    <>
      <div className='d-flex align-items-center justify-content-start px-3 ps-4'>
        {/* <div
          className='position-relative'
          style={{
            "--bs-border-color": "var(--theme-light-primary)",
            "--bs-body-bg": "rgba(255,255,255,0.8)",
          }}
        >
          <input
            type='text'
            className='form-control'
            placeholder='Search Question ...'
            aria-label='Search Question ...'
            aria-describedby='faq-search'
            style={{
              minWidth: "260px",
            }}
          />
          <button
            className='btn position-absolute h-100 border-0'
            type='button'
            id='faq-search'
            style={{
              top: "0",
              right: "0",
              padding: ".25rem .5rem .45rem",
            }}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width={22}
              height={22}
              viewBox='0 0 24 24'
              fill='none'
              stroke='var(--theme-light-secondary)'
              strokeWidth={1.5}
              strokeLinecap='round'
              strokeLinejoin='round'
              className='icon icon-tabler icons-tabler-outline icon-tabler-search'
            >
              <path stroke='none' d='M0 0h24v24H0z' fill='none' />
              <path d='M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0' />
              <path d='M21 21l-6 -6' />
            </svg>
          </button>
        </div> */}
      </div>
      {loading ? (
        <div
          className='w-100 position-absolute top-50 start-50 translate-middle d-flex align-items-center justify-content-center gap-3'
          data-testid='glossary-loader'
          style={{
            color: theme === "light" ? "rgb(0,0,0)" : "rgb(255,255,255)",
          }}
        >
          <div
            className=''
            role='status'
            style={{
              fontSize: "1.25rem",
              fontWeight: "300",
              letterSpacing: isRTL ? "" : ".02em",
            }}
          >
            {"Loading FAQs ..."}
          </div>
          <div
            className='spinner-border'
            style={{
              fontSize: "11px",
              height: "24px",
              width: "24px",
              color: theme === "light" ? "var(--theme-light-primary)" : "var(--theme-light-secondary)",
            }}
          >
            <span className='visually-hidden'>Loading...</span>
          </div>
        </div>
      ) : ""}
        <div
          className={`row w-100 mx-auto flex-column justify-content-start flex-nowrap add-custom-scroll${theme === "dark" ? "-dark" : ""}`}
          style={{
            padding: screenSize <= 575 ? "8px" : "4px 12px 10px",
            paddingTop: "10px",
            rowGap: "8px",
            height: screenSize <= 575 ? "calc(100dvh - 200px)" : screenSize <= 991 && screenSize >= 576 ? "calc(100dvh - 253px)" : "calc(100dvh - 180px)",
            overflowY: "auto",
            scrollbarWidth: screenSize >= 576 ? "" : "none",
          }}
        >
          <Accordion data={faqData} />
        </div>
      {/* )} */}
    </>
  );
};

export default Faqs;
